/**
 * stores/layout.ts
 *
 * Layout state shared between the layout components and the pages that adapt to it.
 */

import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { XXL_APP_WIDTH, detectLayoutMode, isTouchDevice, LAYOUT_BREAKPOINTS } from '@/config/layout'

export const useLayoutStore = defineStore('layout', () => {
    // fixed for the lifetime of the page
    const mode = ref(detectLayoutMode())
    const isTouch = ref(isTouchDevice())
    const isFixedWidth = ref(mode.value === 'three' && window.innerWidth >= LAYOUT_BREAKPOINTS.xxl)
    const appWidth = XXL_APP_WIDTH

    // the FILE pane was dragged shut (multi pane layouts only)
    const fileCollapsed = ref(false)
    // a file was opened while the FILE pane is collapsed: show it alone, as on a phone
    const fileOnly = ref(false)

    // FOLDER (or FOLDER_LIST) and FILE are visible next to each other
    const isSplit = computed(() => mode.value !== 'one' && !fileCollapsed.value)
    const showFolderBack = computed(() => mode.value !== 'three')
    const showFileBack = computed(() => !isSplit.value)

    return {
        mode,
        isTouch,
        isFixedWidth,
        appWidth,
        fileCollapsed,
        fileOnly,
        isSplit,
        showFolderBack,
        showFileBack,
    }
})
